import { defineStore } from 'pinia';
import AdminService from '@/services/admin.service';

export const DASHBOARD_ACTIONS = [
    { key: 'HIDE_INSCRIRE_PARTICIPANT', label: 'Inscrire un participant', subtitle: 'ou un groupe' },
    { key: 'HIDE_INSCRIRE_BILLETTERIE', label: 'Inscrire un participant', subtitle: 'en mode billetterie' },
    { key: 'HIDE_FICHES_PARTICIPANTS', label: 'Accéder aux fiches participants', subtitle: 'au module' },
    { key: 'HIDE_FICHES_PREINSCRITS', label: 'Accéder aux fiches des préinscrits', subtitle: 'du module' },
    { key: 'HIDE_VALIDER_PREINSCRIPTIONS', label: 'Valider les préinscriptions', subtitle: 'du module' },
    { key: 'HIDE_LISTE_ATTENTE_BOURSE', label: "Gérer la liste d'attente", subtitle: 'de la bourse aux dossards' },
    { key: 'HIDE_VALIDER_DOCUMENTS', label: 'Valider les documents', subtitle: 'des coureurs en attente' },
    { key: 'HIDE_LIENS_VIP', label: "Liens d'inscription", subtitle: 'privilégiés (Elites/Partenaires)' },
    { key: 'HIDE_LIENS_GROUPES', label: 'Liens de groupes', subtitle: 'et suivi partenaire' },
    { key: 'HIDE_CODE_PROMO', label: 'Code promo et réductions', subtitle: 'Consulter et créer' },
    { key: 'HIDE_EXPORTER_INSCRITS', label: 'Exporter la liste des inscrits', subtitle: 'au format EXCEL' },
    { key: 'HIDE_ACCUEIL_QR_CODE', label: 'Accueil des participants - Accès bénévoles', subtitle: 'Donner l\'accès aux bénévoles en scannant ce QR-Code' },
    { key: 'HIDE_PRESTATIONS', label: 'Consulter les prestations', subtitle: 'proposées par Sportips' },
    { key: 'HIDE_LIEN_MODULE_FERME', label: "Lien d'accès au module", subtitle: 'une fois fermé' },
    { key: 'HIDE_PODIUMS', label: 'Prévisualiser les podiums', subtitle: 'à récompenser' },
    { key: 'HIDE_CRENEAUX_DOSSARD', label: 'Gérer les créneaux', subtitle: 'de retrait de dossard' },
    { key: 'HIDE_MULTI_PARCOURS', label: 'Liste des inscrits', subtitle: 'à plusieurs parcours' },
    { key: 'HIDE_CONFIG_MODULE', label: 'Editer la configuration', subtitle: "du module d'inscription" },
];

export const useDashboardConfigStore = defineStore('dashboardConfig', {
    state: () => ({
        configs: [],
        loading: false,
        loaded: false,
        id_module: null,
    }),
    getters: {
        isHidden: (state) => (name) => state.configs.some((c) => c.name === name),
        getConfigByName: (state) => (name) => state.configs.find((c) => c.name === name) || null,
    },
    actions: {
        async fetch(id_module) {
            if (!id_module) return false;
            this.loading = true;
            this.id_module = id_module;
            const res = await AdminService.getDashboardConfig(id_module);
            if (res && Array.isArray(res)) {
                this.configs = res;
                this.loaded = true;
                this.loading = false;
                return true;
            }
            this.configs = [];
            this.loaded = true;
            this.loading = false;
            return false;
        },
        async hide(name) {
            if (!this.id_module || !name) return false;
            if (this.isHidden(name)) return true;
            const res = await AdminService.addDashboardConfig({
                id_module: this.id_module,
                name,
            });
            if (res && res.id) {
                if (!this.configs.find((c) => c.id === res.id)) {
                    this.configs.push({
                        id: res.id,
                        id_module: res.id_module,
                        name: res.name,
                    });
                }
                return true;
            }
            return false;
        },
        async show(name) {
            const config = this.getConfigByName(name);
            if (!config) return true;
            const res = await AdminService.deleteDashboardConfig(config.id);
            if (res !== false) {
                this.configs = this.configs.filter((c) => c.id !== config.id);
                return true;
            }
            return false;
        },
        async toggle(name) {
            if (this.isHidden(name)) {
                return this.show(name);
            }
            return this.hide(name);
        },
    },
});
